import { UsersRolesAttributes } from './config/constant';
import { containsElements } from './utils/otherUtilities';

/**
 * Returns the menu items according to the provided User Roles and translation function
 * @param {*} userRoles
 * @param {Function} t - i18next translation function
 * @returns
 */
export const getMenuItems = (userRoles, t = (k) => k) => {
    const menuItems = [
        {
            id: 'navigation',
            title: t('navigation:groups.home'),
            type: 'group',
            icon: 'icon-navigation',
            children: [
                {
                    id: 'dashboard',
                    title: t('navigation:items.dashboard'),
                    type: 'item',
                    url: '/',
                    icon: 'feather icon-home purple'
                },
                containsElements(userRoles, [UsersRolesAttributes.CONSULT_STATS, UsersRolesAttributes.CONSULT_DETAILED_STATS]) && {
                    id: 'stats',
                    title: t('navigation:groups.statistics'),
                    type: 'collapse',
                    icon: 'fa fa-database primary',
                    children: [
                        containsElements(userRoles, [UsersRolesAttributes.CONSULT_STATS, UsersRolesAttributes.CONSULT_DETAILED_STATS]) && {
                            id: 'examsList',
                            title: t('navigation:items.statsGeneral'),
                            type: 'item',
                            url: '/statistics'
                            // icon: 'feather icon-wheel-chair'
                        },
                        containsElements(userRoles, [UsersRolesAttributes.CONSULT_DETAILED_STATS]) && {
                            id: 'examsTubes',
                            title: t('navigation:items.statsInsurances'),
                            type: 'item',
                            url: '/statistics/insurances'
                            // icon: 'feather icon-user success'
                        }
                        // containsElements(userRoles, [UsersRolesAttributes.CONSULT_DETAILED_STATS]) && {
                        //     id: 'examsTypes',
                        //     title: "Sous-traitances",
                        //     type: 'item',
                        //     url: '/statistics/sous-traitance',
                        //     // icon: 'feather icon-user success'
                        // },
                        // containsElements(userRoles, [UsersRolesAttributes.CONSULT_DETAILED_STATS]) && {
                        //     id: 'antiBioFongi',
                        //     title: "Antibiogrammes et Antifongigrammes",
                        //     type: 'item',
                        //     url: '/statistics/antibiogrammes-fongigrammes',
                        //     // icon: 'feather icon-user success'
                        // },
                    ]
                }
            ]
        },
        containsElements(userRoles, [
            UsersRolesAttributes.ADD_PATIENT_OR_PRESCRIPBER,
            UsersRolesAttributes.EDIT_PATIENT_OR_PRESCRIPBER,
            UsersRolesAttributes.DELETE_PATIENT,
            UsersRolesAttributes.BILL_AND_PRESCRIPTION_MANAGER,
            UsersRolesAttributes.DELETE_BILL,
            UsersRolesAttributes.EDIT_USER_PASSWORD,
            UsersRolesAttributes.ADD_STAFF_MEMBER,
            UsersRolesAttributes.EDIT_STAFF_MEMBER,
            UsersRolesAttributes.DELETE_STAFF_MEMBER,
            UsersRolesAttributes.ADD_PATIENT_OR_PRESCRIPBER,
            UsersRolesAttributes.EDIT_PATIENT_OR_PRESCRIPBER,
            UsersRolesAttributes.CONSULT_PACK_SUBSCRIBERS,
            UsersRolesAttributes.CONSULT_PACK_SUBSCRIBERS_CALENDAR,
            UsersRolesAttributes.CONSULT_UNPAIDS,
            UsersRolesAttributes.DELETE_PRESCRIBER
        ]) && {
            id: 'patients',
            title: t('navigation:groups.patients'),
            type: 'group',
            icon: 'icon-group',
            children: [
                containsElements(userRoles, [
                    UsersRolesAttributes.ADD_PATIENT_OR_PRESCRIPBER,
                    UsersRolesAttributes.EDIT_PATIENT_OR_PRESCRIPBER,
                    UsersRolesAttributes.DELETE_PATIENT,
                    UsersRolesAttributes.BILL_AND_PRESCRIPTION_MANAGER,
                    UsersRolesAttributes.DELETE_BILL,
                    UsersRolesAttributes.EDIT_USER_PASSWORD
                ]) && {
                    id: 'patients',
                    title: t('navigation:items.patients'),
                    type: 'item',
                    url: '/users/patients',
                    icon: 'feather icon-users success'
                },
                containsElements(userRoles, [
                    UsersRolesAttributes.CONSULT_PACK_SUBSCRIBERS,
                    UsersRolesAttributes.CONSULT_PACK_SUBSCRIBERS_CALENDAR
                ]) && {
                    id: 'packsSubscribers',
                    title: t('navigation:items.packSubscribers'),
                    type: 'item',
                    url: '/users/pack-subscribers',
                    icon: 'feather icon-users info'
                },
                containsElements(userRoles, [UsersRolesAttributes.CONSULT_UNPAIDS]) && {
                    id: 'patientsSolvabilities',
                    title: t('navigation:items.patientsSolvabilities'),
                    type: 'item',
                    url: '/users/patients-solvabilities',
                    icon: 'feather icon-users danger'
                }
            ]
        },
        containsElements(userRoles, [
            UsersRolesAttributes.ADD_PATIENT_OR_PRESCRIPBER,
            UsersRolesAttributes.EDIT_PATIENT_OR_PRESCRIPBER,
            UsersRolesAttributes.DELETE_PATIENT,
            UsersRolesAttributes.BILL_AND_PRESCRIPTION_MANAGER,
            UsersRolesAttributes.DELETE_BILL,
            UsersRolesAttributes.EDIT_USER_PASSWORD,
            UsersRolesAttributes.ADD_STAFF_MEMBER,
            UsersRolesAttributes.EDIT_STAFF_MEMBER,
            UsersRolesAttributes.DELETE_STAFF_MEMBER,
            UsersRolesAttributes.ADD_PATIENT_OR_PRESCRIPBER,
            UsersRolesAttributes.EDIT_PATIENT_OR_PRESCRIPBER,
            UsersRolesAttributes.DELETE_PRESCRIBER
        ]) && {
            id: 'users',
            title: t('navigation:groups.users'),
            type: 'group',
            icon: 'icon-group',
            children: [
                containsElements(userRoles, [
                    UsersRolesAttributes.ADD_STAFF_MEMBER,
                    UsersRolesAttributes.EDIT_STAFF_MEMBER,
                    UsersRolesAttributes.DELETE_STAFF_MEMBER
                ]) && {
                    id: 'staff',
                    title: t('navigation:items.staff'),
                    type: 'item',
                    url: '/users/staff',
                    icon: 'feather icon-user warning'
                },
                containsElements(userRoles, [
                    UsersRolesAttributes.ADD_PATIENT_OR_PRESCRIPBER,
                    UsersRolesAttributes.EDIT_PATIENT_OR_PRESCRIPBER,
                    UsersRolesAttributes.DELETE_PRESCRIBER
                ]) && {
                    id: 'prescribers',
                    title: t('navigation:items.prescribers'),
                    type: 'item',
                    url: '/users/prescribers',
                    icon: 'feather icon-user info'
                }
            ]
        },
        containsElements(userRoles, [
            UsersRolesAttributes.PERSONAL_CAISSE,
            UsersRolesAttributes.CONSULT_AND_PRINT_CAISSE_STATE,
            UsersRolesAttributes.EDIT_CAISSE_OUTPUT,
            UsersRolesAttributes.VALIDATE_CAISSE_OUTPUT,
            UsersRolesAttributes.CANCEL_VALIDATED_CAISSE_OUTPUT,
            UsersRolesAttributes.CONSULT_AND_PRINT_QUOTE_PART,
            UsersRolesAttributes.ADD_QUOTE_PART,
            UsersRolesAttributes.DELETE_QUOTE_PART
        ]) && {
            id: 'caisse',
            title: t('navigation:groups.caisse'),
            type: 'group',
            icon: 'icon-group',
            children: [
                containsElements(userRoles, [UsersRolesAttributes.PERSONAL_CAISSE]) && {
                    id: 'personnalCash',
                    title: t('navigation:items.personalCash'),
                    type: 'item',
                    url: '/cash/personnal',
                    icon: 'far fa-money-bill-alt warning'
                    // icon: 'feather icon-wheel-chair'
                },
                containsElements(userRoles, [UsersRolesAttributes.CONSULT_AND_PRINT_CAISSE_STATE]) && {
                    id: 'generalCash',
                    title: t('navigation:items.generalCash'),
                    type: 'item',
                    url: '/cash/general',
                    icon: 'fas fa-money-bill-wave success'
                },
                containsElements(userRoles, [UsersRolesAttributes.PERSONAL_CAISSE, UsersRolesAttributes.CONSULT_AND_PRINT_CAISSE_STATE]) && {
                    id: 'cautions',
                    title: t('navigation:items.cautions'),
                    type: 'item',
                    url: '/cash/cautions',
                    icon: 'far fa-money-bill-alt info'
                    // icon: 'feather icon-wheel-chair'
                },
                containsElements(userRoles, [
                    UsersRolesAttributes.EDIT_CAISSE_OUTPUT,
                    UsersRolesAttributes.VALIDATE_CAISSE_OUTPUT,
                    UsersRolesAttributes.CANCEL_VALIDATED_CAISSE_OUTPUT
                ]) && {
                    id: 'bootstrap',
                    title: t('navigation:items.cashOutputs'),
                    type: 'item',
                    url: '/cash/cash-outputs',
                    icon: 'fas fa-money-bill-wave danger'
                },
                containsElements(userRoles, [
                    UsersRolesAttributes.CONSULT_AND_PRINT_QUOTE_PART,
                    UsersRolesAttributes.ADD_QUOTE_PART,
                    UsersRolesAttributes.DELETE_QUOTE_PART
                ]) && {
                    id: 'doctorsCotePart',
                    title: t('navigation:items.quoteParts'),
                    type: 'item',
                    url: '/cash/quote-part',
                    icon: 'fas fa-money-check-alt primary'
                }
            ]
        },
        containsElements(userRoles, [
            UsersRolesAttributes.CONSULT_PATIENTS_LIST,
            UsersRolesAttributes.CONSULT_PATIENTS_RDV,
        ]) && {
            id: 'consultations-hospitalizations',
            // title: 'Technique',
            title: t('navigation:groups.consultations'),
            type: 'group',
            icon: 'icon-group',
            children: [
                containsElements(userRoles, [UsersRolesAttributes.CONSULT_PATIENTS_LIST]) && {
                    id: 'sampling',
                    title: t('navigation:items.consultationPatients'),
                    type: 'item',
                    url: '/consultations-hospitalizations/patients',
                    icon: 'feather icon-user danger'
                },
                containsElements(userRoles, [UsersRolesAttributes.CONSULT_PATIENTS_RDV]) && {
                    id: 'rdv',
                    title: t('navigation:items.appointments'),
                    type: 'item',
                    url: '/consultations-hospitalizations/rendez-vous',
                    icon: 'feather icon-calendar success'
                },
            ]
        },
        containsElements(userRoles, [
            UsersRolesAttributes.CONSULT_CPN_PATIENTS_LIST,
            UsersRolesAttributes.CONSULT_CPN_PATIENTS_RDV,
        ]) && {
            id: 'cpn',
            // title: 'Technique',
            title: t('navigation:groups.cpn'),
            type: 'group',
            icon: 'icon-group',
            children: [
                containsElements(userRoles, [UsersRolesAttributes.CONSULT_CPN_PATIENTS_LIST]) && {
                    id: 'sampling',
                    title: t('navigation:items.cpnPatients'),
                    type: 'item',
                    url: '/cpn/patients',
                    icon: 'feather icon-user danger'
                },
                containsElements(userRoles, [UsersRolesAttributes.CONSULT_CPN_PATIENTS_RDV]) && {
                    id: 'rdv',
                    title: t('navigation:items.cpnAppointments'),
                    type: 'item',
                    url: '/cpn/rendez-vous',
                    icon: 'feather icon-calendar success'
                },
            ]
        },
        containsElements(userRoles, [
            UsersRolesAttributes.DELETE_DEPARTMENT,
            UsersRolesAttributes.ADD_OR_EDIT_BED_ROOM,
            UsersRolesAttributes.DELETE_BED_ROOM,
            UsersRolesAttributes.ADD_OR_EDIT_BIRTH,
            UsersRolesAttributes.ADD_OR_EDIT_DEATH,
            UsersRolesAttributes.CONSULT_BIRTHS_LIST,
            UsersRolesAttributes.CONSULT_DEATHS_LIST,
            UsersRolesAttributes.CONSULT_BED_OCCUPATION,
            UsersRolesAttributes.CONSULT_HOSPITALIZED_PATIENTS
        ]) && {
            id: 'bedManagement',
            // title: 'Technique',
            // title: 'Gestion des Lits',
            title: t('navigation:groups.hospitalizations'),
            type: 'group',
            icon: 'icon-group',
            children: [
                containsElements(userRoles, [UsersRolesAttributes.CONSULT_HOSPITALIZED_PATIENTS]) && {
                    id: 'hospitalized',
                    title: t('navigation:items.hospitalizedPatients'),
                    type: 'item',
                    url: '/bed-management/hospitalized-patients',
                    icon: 'fa fa-bed warning'
                },
                containsElements(userRoles, [UsersRolesAttributes.CONSULT_BED_OCCUPATION]) && {
                    id: 'bedsStatus',
                    title: t('navigation:items.bedsOverview'),
                    type: 'item',
                    url: '/bed-management/status',
                    icon: 'fa fa-procedures info'
                },
                containsElements(userRoles, [UsersRolesAttributes.ADD_OR_EDIT_BIRTH, UsersRolesAttributes.CONSULT_BIRTHS_LIST]) && {
                    id: 'births',
                    title: t('navigation:items.births'),
                    type: 'item',
                    url: '/bed-management/births',
                    icon: 'fa fa-baby success'
                },
                containsElements(userRoles, [UsersRolesAttributes.ADD_OR_EDIT_DEATH, UsersRolesAttributes.CONSULT_DEATHS_LIST]) && {
                    id: 'deaths',
                    title: t('navigation:items.deaths'),
                    type: 'item',
                    url: '/bed-management/deaths',
                    icon: 'fa fa-skull-crossbones danger'
                },
                containsElements(userRoles, [
                    UsersRolesAttributes.DELETE_DEPARTMENT,
                    UsersRolesAttributes.ADD_OR_EDIT_BED_ROOM,
                    UsersRolesAttributes.DELETE_BED_ROOM
                ]) && {
                    id: 'bedConfigss',
                    title: t('navigation:items.bedsConfiguration'),
                    type: 'item',
                    url: '/bed-management/configs',
                    icon: 'feather icon-settings primary'
                }
            ]
        },

        containsElements(userRoles, [
            UsersRolesAttributes.CONSULT_PHARMACY_STOCK_STATE,
            UsersRolesAttributes.INITIATE_PHARMACY_STOCK_MOVEMENT,
            UsersRolesAttributes.COMMAND_PHARMACY_MEDICINES,
            UsersRolesAttributes.PAY_PHARMACY_BILL,
            UsersRolesAttributes.CONSULT_PHARMACY_STATS,
            UsersRolesAttributes.CONFIGURE_MEDICINES_KITS,
            UsersRolesAttributes.ADD_OR_EDIT_MEDCINES,
            UsersRolesAttributes.IMPORT_EXPORT_PHARMACY_STOCK,
            UsersRolesAttributes.PROCESS_UNORDERED_DELIVERIES
        ]) && {
            id: 'pharmacy',
            title: t('navigation:groups.pharmacy'),
            type: 'group',
            icon: 'icon-group',
            children: [
                containsElements(userRoles, [
                    UsersRolesAttributes.CONSULT_PHARMACY_STOCK_STATE,
                    UsersRolesAttributes.INITIATE_PHARMACY_STOCK_MOVEMENT
                ]) && {
                    id: 'pharmacyStockstate',
                    title: t('navigation:items.pharmacyInventory'),
                    type: 'item',
                    url: '/pharmacy/stock-state',
                    icon: 'fa fa-warehouse primary'
                },
                containsElements(userRoles, [
                    UsersRolesAttributes.COMMAND_PHARMACY_MEDICINES,
                    UsersRolesAttributes.RECEIVE_PHARMACY_MEDICINES
                ]) && {
                    id: 'stockInputs',
                    title: t('navigation:items.medicineInputs'),
                    type: 'item',
                    // icon: 'icon-group',
                    icon: 'feather icon-arrow-down success',
                    url: '/pharmacy/medicine-commands'
                    // children: [
                    //     containsElements(userRoles, [UsersRolesAttributes.CONSULT_BENCH_BOOK]) && {
                    //         id: 'medicinesCommands',
                    //         title: 'Commandes',
                    //         type: 'item',
                    //     },
                    //     containsElements(userRoles, [UsersRolesAttributes.CONSULT_BENCH_BOOK]) && {
                    //         id: 'medicinesReceptions',
                    //         title: 'Réceptions',
                    //         type: 'item',
                    //         url: '/pharmacy/medicine-receptions'
                    //         // icon: 'feather icon-settings success'
                    //     }
                    // ]
                },
                containsElements(userRoles, [UsersRolesAttributes.PROCESS_UNORDERED_DELIVERIES]) && {
                    id: 'unorderedDeliveries',
                    title: t('navigation:items.unorderedDeliveries'),
                    type: 'item',
                    url: '/pharmacy/unordered-deliveries',
                    icon: 'feather icon-alert-triangle warning'
                },
                containsElements(userRoles, [UsersRolesAttributes.INITIATE_PHARMACY_STOCK_MOVEMENT, UsersRolesAttributes.CONSULT_PHARMACY_STOCK_STATE]) && {
                    id: 'stockOuts',
                    title: t('navigation:items.stockOuts'),
                    type: 'item',
                    url: '/pharmacy/stock-outs',
                    icon: 'feather icon-minus-circle danger'
                },
                containsElements(userRoles, [UsersRolesAttributes.INITIATE_PHARMACY_STOCK_MOVEMENT, UsersRolesAttributes.CONSULT_PHARMACY_STOCK_STATE]) && {
                    id: 'stockReturns',
                    title: t('navigation:items.stockReturns'),
                    type: 'item',
                    url: '/pharmacy/stock-returns',
                    icon: 'feather icon-corner-up-left success'
                },
                containsElements(userRoles, [UsersRolesAttributes.PAY_PHARMACY_BILL, UsersRolesAttributes.CREATE_PHARMACY_BILL]) && {
                    id: 'medecineSales',
                    title: t('navigation:items.pharmacySales'),
                    type: 'item',
                    url: '/pharmacy/medicine-selling',
                    icon: 'feather icon-arrow-up primary'
                },
                containsElements(userRoles, [UsersRolesAttributes.PAY_PHARMACY_BILL, UsersRolesAttributes.CREATE_PHARMACY_BILL]) && {
                    id: 'medecineSalesFromHospitalized',
                    title: t('navigation:items.hospitalizedOrders'),
                    type: 'item',
                    url: '/pharmacy/medicine-selling-for-hospitalized',
                    icon: 'fa fa-procedures info'
                },
                containsElements(userRoles, [UsersRolesAttributes.CONFIGURE_MEDICINES_KITS]) && {
                    id: 'medicinesKits',
                    title: t('navigation:items.medicineKits'),
                    type: 'item',
                    url: '/pharmacy/medicines-kits',
                    icon: 'feather icon-box primary'
                },
                containsElements(userRoles, [
                    UsersRolesAttributes.CONSULT_PHARMACY_CAISSE_GENERALE_STATS,
                    UsersRolesAttributes.CONSULT_PHARMACY_CAISSE_PERSONNELLE_STATS
                ]) && {
                    id: 'pharmacyReports',
                    // title: 'Rapports & Stats',
                    title: t('navigation:items.pharmacyCash'),
                    type: 'item',
                    url: '/pharmacy/payment-reports',
                    icon: 'fas fa-money-check-alt success'
                },
                containsElements(userRoles, [UsersRolesAttributes.CONSULT_PHARMACY_STATS]) && {
                    id: 'pharmacyReports',
                    // title: 'Rapports & Stats',
                    title: t('navigation:items.pharmacyReports'),
                    type: 'item',
                    url: '/pharmacy/reports-and-stats',
                    icon: 'fa fa-database warning'
                },
                containsElements(userRoles, [UsersRolesAttributes.CONSULT_PHARMACY_MEDICINE_HISTORIES]) && {
                    id: 'pharmacyReports',
                    title: t('navigation:items.pharmacyHistories'),
                    type: 'item',
                    url: '/pharmacy/medicine-histories',
                    icon: 'fas fa-history danger'
                },
                containsElements(userRoles, [
                    UsersRolesAttributes.ADD_OR_EDIT_MEDCINES,
                    UsersRolesAttributes.DELETE_MEDCINES,
                    UsersRolesAttributes.IMPORT_EXPORT_PHARMACY_STOCK
                ]) && {
                    id: 'pharmacySettings',
                    title: t('navigation:items.pharmacySettings'),
                    type: 'collapse',
                    // icon: 'icon-group',
                    icon: 'feather icon-settings success',
                    children: [
                        containsElements(userRoles, [UsersRolesAttributes.ADD_OR_EDIT_MEDCINES, UsersRolesAttributes.DELETE_MEDCINES]) && {
                            id: 'medicines',
                            title: t('navigation:items.medicineConfig'),
                            type: 'item',
                            url: '/pharmacy/medicines'
                        },
                        containsElements(userRoles, [UsersRolesAttributes.ADD_OR_EDIT_MEDCINES, UsersRolesAttributes.DELETE_MEDCINES]) && {
                            id: 'suppliers',
                            title: t('navigation:items.suppliersManagement'),
                            type: 'item',
                            url: '/pharmacy/suppliers'
                            // icon: 'feather icon-settings success'
                        },
                        containsElements(userRoles, [UsersRolesAttributes.IMPORT_EXPORT_PHARMACY_STOCK]) && {
                            id: 'importExportStock',
                            title: t('navigation:items.importExport'),
                            type: 'item',
                            url: '/pharmacy/import-export'
                        }
                    ]
                },
                containsElements(userRoles, [UsersRolesAttributes.CONSULT_PHARMACY_SUPPLIERS_BILLS]) && {
                    id: 'pharmacySuppliersPayment',
                    title: t('navigation:items.suppliersPayments'),
                    type: 'item',
                    url: '/pharmacy/suppliers-payments',
                    icon: 'fa fa-hand-holding-usd danger'
                }
            ]
        },
        containsElements(userRoles, [
            UsersRolesAttributes.CONSULT_BENCH_BOOK,
            UsersRolesAttributes.SAMPLE_PATIENTS,
            UsersRolesAttributes.TREAT_SAMPLES,
            UsersRolesAttributes.VALIDATE_SAMPLES,
            UsersRolesAttributes.PRINT_AND_WITHDRAW_RESULTS
        ]) && {
            id: 'technique',
            // title: 'Technique',
            title: t('navigation:groups.technique'),
            type: 'group',
            icon: 'icon-group',
            children: [
                containsElements(userRoles, [UsersRolesAttributes.SAMPLE_PATIENTS]) && {
                    id: 'sampling',
                    title: t('navigation:items.sampling'),
                    type: 'item',
                    url: '/technique/samplings',
                    icon: 'feather icon-user warning'
                },
                containsElements(userRoles, [UsersRolesAttributes.CONSULT_BENCH_BOOK]) && {
                    id: 'benchBook',
                    title: t('navigation:items.benchBook'),
                    type: 'item',
                    url: '/technique/bench-book',
                    icon: 'feather icon-book purple'
                },
                containsElements(userRoles, [UsersRolesAttributes.TREAT_SAMPLES]) && {
                    id: 'units',
                    title: t('navigation:items.techUnits'),
                    type: 'item',
                    url: '/technique/units',
                    icon: 'feather icon-calendar info'
                },
                containsElements(userRoles, [UsersRolesAttributes.VALIDATE_SAMPLES]) && {
                    id: 'resultsValidating',
                    title: t('navigation:items.pendingValidation'),
                    type: 'item',
                    url: '/technique/validation',
                    icon: 'feather icon-check-circle success'
                },
                containsElements(userRoles, [UsersRolesAttributes.PRINT_AND_WITHDRAW_RESULTS]) && {
                    id: 'resultPrint',
                    title: t('navigation:items.printAndWithdraw'),
                    type: 'item',
                    url: '/technique/print-and-withdraw',
                    icon: 'feather icon-printer danger'
                },
                containsElements(userRoles, [UsersRolesAttributes.CONSULT_GENERAL_PRESCRIPTIONS_HISTORIES]) && {
                    id: 'generalHistories',
                    title: t('navigation:items.prescriptionsState'),
                    type: 'item',
                    url: '/technique/general-histories',
                    icon: 'fas fa-history warning'
                }
            ]
        },
         containsElements(userRoles, [
            UsersRolesAttributes.ACCESS_IMAGING_MODULE,
        ]) && {
            id: 'imaging',
            // title: 'Technique',
            title: t('navigation:groups.imaging'),
            type: 'group',
            icon: 'icon-group',
            children: [
                containsElements(userRoles, [UsersRolesAttributes.ACCESS_IMAGING_MODULE]) && {
                    id: 'sampling',
                    title: t('navigation:items.imagingPatients'),
                    type: 'item',
                    url: '/imaging/patients',
                    icon: 'feather icon-user warning'
                },
            ]
        },
        containsElements(userRoles, [
            UsersRolesAttributes.ADD_OR_EDIT_EXAMS,
            UsersRolesAttributes.EDIT_EXAMS_SETTINGS,
            UsersRolesAttributes.DELETE_EXAMS,
            UsersRolesAttributes.ADD_OR_EDIT_EXAMS_TUBES,
            UsersRolesAttributes.DELETE_EXAMS_TUBES,
            UsersRolesAttributes.ADD_OR_EDIT_EXAMS_TYPES,
            UsersRolesAttributes.DELETE_EXAMS_TYPES,
            UsersRolesAttributes.EDIT_EXAMS_TYPES_SETTINGS,
            UsersRolesAttributes.EDIT_QUOTE_PART_PERCENTAGE,
            UsersRolesAttributes.ADD_OR_EDIT_RESULTS_BANK,
            UsersRolesAttributes.DELETE_RESULTS_BANK,
            UsersRolesAttributes.ADD_OR_EDIT_LABS,
            UsersRolesAttributes.DELETE_LABS,
            UsersRolesAttributes.ADD_OR_EDIT_PARTNERS,
            UsersRolesAttributes.DELETE_PARTNERS,
            UsersRolesAttributes.ADD_CAISSE_OUTPUT_ORDONNATOR,
            UsersRolesAttributes.EDIT_CAISSE_OUTPUT_ORDONNATOR,
            UsersRolesAttributes.DELETE_CAISSE_OUTPUT_ORDONNATOR,
            UsersRolesAttributes.ADD_CAISSE_OUTPUT_DOMAIN,
            UsersRolesAttributes.EDIT_CAISSE_OUTPUT_DOMAIN,
            UsersRolesAttributes.DELETE_CAISSE_OUTPUT_DOMAIN,
            UsersRolesAttributes.CONSULT_HISTORIES,
            UsersRolesAttributes.EDIT_USER_PROFILE
        ]) && {
            id: 'administration',
            title: t('navigation:groups.administration'),
            type: 'group',
            icon: 'icon-group',
            children: [
                // containsElements(userRoles, [UsersRolesAttributes.CONFIGURE_PACKS]) && {
                containsElements(userRoles, [UsersRolesAttributes.VALIDATE_PENDING_DISCOUNTS]) && {
                    id: 'forms',
                    title: t('navigation:items.adminPacks'),
                    type: 'item',
                    url: '/admin/packs-configs',
                    icon: 'fas fa-gift warning'
                },
                // containsElements(userRoles, [UsersRolesAttributes.VALIDATE_PENDING_DISCOUNTS]) && {
                //     id: 'forms',
                //     title: 'Réductions en Attente',
                //     type: 'item',
                //     url: '/admin/pending-discounts',
                //     icon: 'feather icon-clock success'
                // },
                containsElements(userRoles, [UsersRolesAttributes.VALIDATE_PENDING_DISCOUNTS]) && {
                    id: 'forms',
                    title: t('navigation:items.adminDiscounts'),
                    type: 'item',
                    url: '/admin/discounts',
                    icon: 'feather icon-clock success'
                },
                containsElements(userRoles, [
                    UsersRolesAttributes.CONSULT_EXAMS_LIST,
                    UsersRolesAttributes.ADD_OR_EDIT_EXAMS,
                    UsersRolesAttributes.EDIT_EXAMS_SETTINGS,
                    UsersRolesAttributes.DELETE_EXAMS,
                    UsersRolesAttributes.ADD_OR_EDIT_EXAMS_TUBES,
                    UsersRolesAttributes.DELETE_EXAMS_TUBES,
                    UsersRolesAttributes.ADD_OR_EDIT_EXAMS_TYPES,
                    UsersRolesAttributes.DELETE_EXAMS_TYPES,
                    UsersRolesAttributes.EDIT_EXAMS_TYPES_SETTINGS,
                    UsersRolesAttributes.EDIT_QUOTE_PART_PERCENTAGE,
                    UsersRolesAttributes.ADD_OR_EDIT_RESULTS_BANK,
                    UsersRolesAttributes.DELETE_RESULTS_BANK
                ]) && {
                    id: 'exams',
                    title: t('navigation:items.adminExams'),
                    type: 'collapse',
                    // icon: 'icon-group',
                    icon: 'feather icon-file primary',
                    children: [
                        containsElements(userRoles, [
                            UsersRolesAttributes.CONSULT_EXAMS_LIST,
                            UsersRolesAttributes.ADD_OR_EDIT_EXAMS,
                            UsersRolesAttributes.EDIT_EXAMS_SETTINGS,
                            UsersRolesAttributes.DELETE_EXAMS
                        ]) && {
                            id: 'examsList',
                            title: t('navigation:items.adminExamsList'),
                            type: 'item',
                            url: '/admin/exams/list'
                            // icon: 'feather icon-wheel-chair'
                        },
                        {
                            id: 'examsKits',
                            title: t('navigation:items.adminExamsKits'),
                            type: 'item',
                            url: '/admin/exams/kits'
                            // icon: 'feather icon-user warning'
                        },
                        containsElements(userRoles, [
                            UsersRolesAttributes.ADD_OR_EDIT_EXAMS_TUBES,
                            UsersRolesAttributes.DELETE_EXAMS_TUBES
                        ]) && {
                            id: 'examsTubes',
                            title: t('navigation:items.adminExamsTubes'),
                            type: 'item',
                            url: '/admin/exams/tubes'
                            // icon: 'feather icon-user success'
                        },
                        containsElements(userRoles, [
                            UsersRolesAttributes.ADD_OR_EDIT_EXAMS_TYPES,
                            UsersRolesAttributes.DELETE_EXAMS_TYPES,
                            UsersRolesAttributes.EDIT_EXAMS_TYPES_SETTINGS,
                            UsersRolesAttributes.EDIT_QUOTE_PART_PERCENTAGE
                        ]) && {
                            id: 'examsTypes',
                            title: t('navigation:items.adminExamsTypes'),
                            type: 'item',
                            url: '/admin/exams/types'
                            // icon: 'feather icon-user success'
                        },
                        containsElements(userRoles, [
                            UsersRolesAttributes.ADD_OR_EDIT_RESULTS_BANK,
                            UsersRolesAttributes.DELETE_RESULTS_BANK
                        ]) && {
                            id: 'benchesTechniques',
                            title: t('navigation:items.adminResultsBank'),
                            type: 'item',
                            url: '/admin/exams/parameters-results'
                            // icon: 'feather icon-user success'
                        }
                    ]
                },
                containsElements(userRoles, [
                    UsersRolesAttributes.ADD_OR_EDIT_LABS,
                    UsersRolesAttributes.DELETE_LABS,
                    UsersRolesAttributes.ADD_OR_EDIT_PARTNERS,
                    UsersRolesAttributes.DELETE_PARTNERS,
                    UsersRolesAttributes.ADD_CAISSE_OUTPUT_ORDONNATOR,
                    UsersRolesAttributes.EDIT_CAISSE_OUTPUT_ORDONNATOR,
                    UsersRolesAttributes.DELETE_CAISSE_OUTPUT_ORDONNATOR,
                    UsersRolesAttributes.ADD_CAISSE_OUTPUT_DOMAIN,
                    UsersRolesAttributes.EDIT_CAISSE_OUTPUT_DOMAIN,
                    UsersRolesAttributes.DELETE_CAISSE_OUTPUT_DOMAIN
                ]) && {
                    id: 'configs',
                    title: t('navigation:items.adminConfigurations'),
                    type: 'collapse',
                    icon: 'feather icon-settings info',
                    children: [
                        containsElements(userRoles, [UsersRolesAttributes.ADD_OR_EDIT_LABS, UsersRolesAttributes.DELETE_LABS]) && {
                            id: 'laboratories',
                            title: t('navigation:items.adminStructures'),
                            type: 'item',
                            url: '/admin/configs/laboratories'
                        },
                        containsElements(userRoles, [UsersRolesAttributes.ADD_OR_EDIT_PARTNERS, UsersRolesAttributes.DELETE_PARTNERS]) && {
                            id: 'partners',
                            title: t('navigation:items.adminPartners'),
                            type: 'item',
                            url: '/admin/configs/partners'
                        },
                        containsElements(userRoles, [
                            UsersRolesAttributes.ADD_CAISSE_OUTPUT_ORDONNATOR,
                            UsersRolesAttributes.EDIT_CAISSE_OUTPUT_ORDONNATOR,
                            UsersRolesAttributes.DELETE_CAISSE_OUTPUT_ORDONNATOR,
                            UsersRolesAttributes.ADD_CAISSE_OUTPUT_DOMAIN,
                            UsersRolesAttributes.EDIT_CAISSE_OUTPUT_DOMAIN,
                            UsersRolesAttributes.DELETE_CAISSE_OUTPUT_DOMAIN
                        ]) && {
                            id: 'caisse',
                            title: t('navigation:items.adminCaisseConfig'),
                            type: 'item',
                            url: '/admin/configs/caisse'
                        },
                        containsElements(userRoles, [
                            UsersRolesAttributes.ADD_CAISSE_OUTPUT_ORDONNATOR,
                        ]) && {
                            id: 'hospitalisations-settings',
                            title: t('navigation:items.adminHospitalizationSettings'),
                            type: 'item',
                            url: '/admin/configs/hospitalisations-settings'
                        }
                    ]
                },
                // containsElements(userRoles, [UsersRolesAttributes.SEND_PUSH_NOTIFICATIONS]) && {
                //     id: 'forms',
                //     title: 'Notifications aux Utilisateurs',
                //     type: 'item',
                //     url: '/admin/push-notifications',
                //     icon: 'feather icon-bell success'
                // },
                containsElements(userRoles, [UsersRolesAttributes.EDIT_USER_PROFILE]) && {
                    id: 'forms',
                    title: t('navigation:items.adminProfiles'),
                    type: 'item',
                    url: '/admin/profiles',
                    icon: 'feather icon-lock danger'
                },
                containsElements(userRoles, [UsersRolesAttributes.HANDLE_TAXES_MANAGEMENT]) && {
                    id: 'forms',
                    title: t('navigation:items.adminTurnover'),
                    type: 'item',
                    url: '/admin/taxes',
                    icon: 'fas fa-money-check-alt warning'
                },
                containsElements(userRoles, [UsersRolesAttributes.CONSULT_HISTORIES]) && {
                    id: 'histories',
                    title: t('navigation:items.adminHistory'),
                    type: 'item',
                    url: '/admin/histories',
                    icon: 'feather icon-file primary'
                }
            ]
        }
    ];

    return menuItems;
};
